export const contextualRelevancyMapping: Record<string, string> = {
  "0": "Not relevant",
  "1": "Low",
  "2": "Medium-low",
  "3": "Medium",
  "4": "Medium-high",
  "5": "High",
};
